<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.practitioners', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <router-link :to="{ name: 'add-practitioner' }" v-if="can">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>


                    <b-container>
                        <b-row class="justify-content-sm-center">

                            <b-col col sm="12">
                                <!--                                <b-form-group>-->
                                <div class="vgt-global-search vgt-clearfix">
                                    <div class="vgt-global-search__input vgt-pull-left"><span class="input__icon">
                                        <div class="magnifying-glass">

                                        </div>
                                    </span>
                                        <input type="text" placeholder="Search user" class="vgt-input vgt-pull-left" v-model="searchTerm">
                                    </div>
                                    <div class="vgt-global-search__actions vgt-pull-right">

                                    </div>
                                </div>
                                <vue-good-table
                                        id="operation"
                                        :columns="mPractitionersColumns"
                                        :rows="mPractitionersFilter"
                                        :search-options="{
                                        enabled:true,
                                        externalQuery: searchTerm
                                        }"
                                        :pagination-options="paginationOptions"
                                        @on-row-click="mPractitionerClick"
                                />
                            </b-col>
                        </b-row>
                    </b-container>

            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "Practitioners",

        computed: {
            ...mapGetters(["practitioners",'hasAdminRole',
                'hasGestionnaireRole','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante;
            },

            mPractitioners: function() {
                let pArray = [];

                _.forEach(_.orderBy(this.practitioners,['created_at'],['desc']), function(practitioner) {
                    let p = {};
                    if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) ){
                        let prenom = practitioner.user.prenom ? practitioner.user.prenom : '';
                        prenom =  prenom.toLowerCase();
                        p.nom =  (practitioner.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        p.email = practitioner.user.email;
                        p.telephone = practitioner.user.telephone;
                        p.numero = practitioner.numero_ordre;
                        p.date = moment(practitioner.created_at).format('DD-MM-YYYY HH:mm');
                        p.id = practitioner.user.id;
                        p.slug = practitioner.user.slug;
                        p.adresse = practitioner.adresse;
                    }

                    pArray.push(p);
                });

                return pArray;
            },

            rows: function() {
                return this.mPractitioners.length;
            }
        },
        watch:{
            searchTerm:function (newValue, oldValue) {
                if (this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante){
                    if (newValue.trim().length ==0){
                        this.mPractitionersFilter = [];
                    }else{
                        this.mPractitionersFilter = this.mPractitioners;
                    }
                }
            }
        },
        data() {
            return {
                mPractitionersFilter:[],
                searchTerm : '',
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
                mPractitionersColumns: [
                    {
                        field: 'nom',
                        label: this.$i18n.t('message.name'),
                    },
                    {
                        field: 'email',
                        label: this.$i18n.t('message.email'),
                    },
                    {
                        field: 'telephone',
                        label: this.$i18n.t('message.phoneNumber'),
                    },
                    {
                        field: 'numero',
                        label: this.$i18n.t('message.orderNumber'),
                    },
                    {
                        field: 'adresse',
                        label: this.$i18n.t('message.address'),
                    },
                    // {
                    //     field: 'action',
                    //     label: this.$i18n.tc('message.operations', 1)
                    // }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getPractitioners() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getPractitioners', { args : args });
            },

            mPractitionerClick(params) {
                this.$router.push({ name: 'practitioner', params: { practitioner: params.row.slug } });
            },

            deletePractitioner(practitioner) {
                let self = this;

                let args = {
                    practitioner: practitioner
                };

                let successMessage = this.$i18n.t('message.practitionerDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deletePractitioner', { args, index: practitioner, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + practitioner);
                    });
            }
        },

        mounted() {
            // Fetch practitioner list
            this.getPractitioners();
        }
    }
</script>

<style scoped>

</style>